/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

import config from './config';

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
    // forgotPassword: 'b2c_1a_passwordreset',
    // editProfile: 'b2c_1a_editprofile',
  },
  authorities: {
    signUpSignIn: {
      // old b2s authority: 'https://iesb2c.b2clogin.com/iesb2c.onmicrosoft.com/b2c_1a_hdr_signup_signin',
      authority: 'https://connect.iesve.cloud/connect.iesve.cloud/B2C_1A_SIGNUP_SIGNIN',
    },
    // forgotPassword: {
    //   authority: 'https://IESB2C.b2clogin.com/IESB2C.onmicrosoft.com/b2c_1a_passwordreset',
    // },
    // editProfile: {
    //   authority: 'https://IESB2C.b2clogin.com/IESB2C.onmicrosoft.com/b2c_1a_editprofile',
    // },
  },
  authorityDomain: 'connect.iesve.cloud',
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    /// OLD B2C clientId: '53e5dada-fbf0-4848-b782-403e45b5b362', // New Client - This is the ONLY mandatory field that you need to supply.
    //clientId: process.env.REACT_APP_CLIENT_ID,
    clientId: config.clientId,
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  apiHello: {
    //endpoint: 'https://localhost:7185/weatherforecast',
    endpoint: 'https://graph.microsoft.com/v1.0/me',
    scopes: [
      //process.env.REACT_APP_CLIENT_SCOPE,
      config.apiScope,

      //'https://IESB2C.b2clogin.com/IESB2C.onmicrosoft.com/B2C_1_B2C/User.ReadWrite.All',
      // 'https://graph.microsoft.com/User.ReadWrite.All',
    ], // e.g. api://xxxxxx/access_as_user
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [...protectedResources.apiHello.scopes],
};
